import URL from 'url-parse';
import $ from 'jquery';
import '../djangoCSRF/djangoCSRF';

var APIURL = function(url, method) {
  const parsedUrl = new URL(url, '/');
  this.url = parsedUrl
    .set(
      'pathname',
      parsedUrl.pathname.endsWith('/')
        ? `/api/${parsedUrl.pathname}`
        : `/api/${parsedUrl.pathname}/`
    )
    .toString();

  this._send = function(type, data, options) {
    var deferred = $.Deferred();
    var errorMessage;
    var ajaxOptions = {
      url: this.url,
      type: type,
      data: data,
      dataType: 'json',
    };

    $.extend(ajaxOptions, options);

    var jqXHR = $.ajax(ajaxOptions)
      .done(function(result) {
        if (!result.hasOwnProperty('error') && result.success !== false) {
          deferred.resolve(result);
        } else {
          var error =
            result && result.hasOwnProperty('error') ? result.error : 'no data';
          deferred.reject('Error: ' + error, result);
        }
      })
      .fail(function(result) {
        var parsed_result;
        try {
          parsed_result = JSON.parse(result.responseText);
          errorMessage = 'Error: ' + parsed_result.error;

          deferred.reject(errorMessage, parsed_result);
          if (parsed_result.errorCode === 4) {
            window.location.reload();
          }
        } catch (err) {
          errorMessage = 'Error ' + result.status + ': ' + result.statusText;
        }
      });

    deferred.abort = jqXHR.abort;

    return deferred;
  };

  this.get = function(data, options) {
    return this._send('GET', data, options);
  };

  this.post = function(data, options) {
    return this._send('POST', data, options);
  };

  this.put = function(data, options) {
    return this._send('PUT', data, options);
  };

  this.del = function(data, options) {
    return this._send('DELETE', data, options);
  };
};

export const get = function(url, data, options) {
  return new APIURL(url).get(data, options);
};

export const post = function(url, data, options) {
  return new APIURL(url).post(data, options);
};

export const put = function(url, data, options) {
  return new APIURL(url).put(data, options);
};

export const del = function(url, data, options) {
  return new APIURL(url).del(data, options);
};
